import { Button, Typography } from 'antd';
import { useDispatch } from 'react-redux';

import { Lineitem } from '../../../interfaces/Ordel.Interface';
import { setOrderLineItem } from '../../../redux/slices/stockPreview';
import { showMaterialSelectionModal } from '../../../redux/slices/material-selection';
import MaterialSelectionModal2 from '../../../components/MaterialSelectionModal2';
import MaterialModal from '../../../components/MaterialModal';
import { useState } from 'react';
import { Material } from '../../../interfaces/MaterialInventory.interface.ts';
import {
	useGetMaterialsQuery,
	useLazyGetMaterialByIdQuery,
} from '../../../redux/api/material.ts';

const { Title } = Typography;

export const MaterialSelection = ({
	lineItem,
	refetchLineItem,
	actionsDisabled,
}: {
	lineItem: Lineitem;
	refetchLineItem: () => void;
	actionsDisabled?: boolean;
}) => {
	const dispatch = useDispatch();

	const materialQuery: any = {};
	const [selectedMaterial, setSelectedMaterial] = useState<Material | null>(
		null
	);
	const [refecthMaterials, setRefetchMaterials] = useState<any>();

	return (
		<>
			<div>
				<Title level={5}>Material</Title>

				<div className="flex flex-row gap-2">
					<Button
						onClick={() => {
							dispatch(showMaterialSelectionModal());
							dispatch(setOrderLineItem(lineItem.id));
						}}
						type="primary"
						disabled={actionsDisabled}
					>
						Reserve Material
					</Button>
				</div>
			</div>

			<MaterialSelectionModal2
				lineItem={lineItem}
				refetchLineItem={refetchLineItem}
				onMaterialSelect={(material: Material, refetch) => {
					setSelectedMaterial(material);
					setRefetchMaterials(() => refetch);
				}}
			/>

			<MaterialModal
				material={selectedMaterial}
				refetchData={() => {
					refetchLineItem();
					if (refecthMaterials) {
						refecthMaterials();
					}
				}}
				onClose={() => setSelectedMaterial(null)}
				redirectToInventory={false}
			/>
		</>
	);
};
